import vpsOciTypes from './vpsOci.types';

export const initialState = {
  data: {
    packageId: null,
    productName: '',
    serverInfo: {
      locked: false,
      reason: '',
    },
    vps: {
      domain: '',
      serverIp: '',
      datacenter: '',
      processor: '',
      memory: '',
      disk: '',
      hasPassword: true,
    },
    ssh: {
      serverIp: '',
      serverPort: '',
      user: '',
    },
    management: [],
    details: {
      registerDate: null,
      nextDueDate: null,
      billingCycle: '',
      paymentMethod: '',
    },
    addons: [],
    availableOptions: {
      operationalSystems: [],
      panels: [],
      applications: [],
    },
  },
  loading: false,
  status: {
    loading: false,
    value: '',
  },
  tour: {
    canShowTour: false,
  },
  rebuild: {
    loading: false,
    status: '',
  },
  changeImage: {
    loading: false,
    data: {},
    status: '',
  },
  openSshTerminal: {
    loading: false,
    url: null,
  },
  isRebooting: false,
  password: {
    loading: false,
    success: false,
  },
  upgrade: {
    listing: {
      loading: false,
      data: null,
    },
    details: {
      loading: false,
      data: null,
    },
    submit: {
      loading: false,
      data: {},
    },
  },
  openClaw: {
    loading: false,
    success: false,
  },
  gatorClaw: {
    loading: false,
    success: false,
  },
};

const vpsOciReducer = (state = initialState, action) => {
  switch (action.type) {
    case vpsOciTypes.GET_VPS_OCI_REQUEST:
      return { ...state, loading: true };
    case vpsOciTypes.SET_VPS_OCI_DATA:
      return { ...state, ...action.payload };
    case vpsOciTypes.VPS_OCI_SET_LOADING:
      return { ...state, loading: action.payload };

    case vpsOciTypes.STATUS_VPS_OCI_REQUEST:
      return { ...state, status: { ...state.status, loading: true } };
    case vpsOciTypes.STATUS_VPS_OCI_DATA:
      return { ...state, status: { ...state.status, value: action.payload } };
    case vpsOciTypes.STATUS_VPS_OCI_LOADING:
      return { ...state, status: { ...state.status, loading: action.payload } };

    case vpsOciTypes.REBOOT_VPS_SET_LOADING:
      return { ...state, isRebooting: action.payload };

    case vpsOciTypes.REBUILD_VPS_REQUEST:
      return { ...state, rebuild: { ...state.rebuild, loading: true, status: '' } };
    case vpsOciTypes.REBUILD_VPS_SET_LOADING:
      return { ...state, rebuild: { ...state.rebuild, loading: action.payload } };
    case vpsOciTypes.REBUILD_VPS_SET_STATUS:
      return { ...state, rebuild: { ...state.rebuild, status: action.payload } };
    case vpsOciTypes.REBUILD_VPS_RESET:
      return { ...state, rebuild: { ...initialState.rebuild } };

    case vpsOciTypes.CHANGE_IMAGE_VPS_REQUEST:
      return { ...state, changeImage: { ...state.changeImage, loading: true } };
    case vpsOciTypes.CHANGE_IMAGE_VPS_SET_LOADING:
      return { ...state, changeImage: { ...state.changeImage, loading: action.payload } };
    case vpsOciTypes.CHANGE_IMAGE_VPS_SET_STATUS:
      return { ...state, changeImage: { ...state.changeImage, status: action.payload } };
    case vpsOciTypes.CHANGE_IMAGE_VPS_SET_DATA:
      return { ...state, changeImage: { ...state.changeImage, data: action.payload } };
    case vpsOciTypes.CHANGE_IMAGE_VPS_RESET:
      return { ...state, changeImage: { ...initialState.changeImage } };

    case vpsOciTypes.SAVE_SSH_PASSWORD_SET_LOADING:
      return { ...state, password: { ...state.password, loading: action.payload } };
    case vpsOciTypes.SAVE_SSH_PASSWORD_SET_SUCCESS:
      return { ...state, password: { ...state.password, success: action.payload } };

    case vpsOciTypes.OPEN_SSH_TERMINAL_SET_LOADING:
      return { ...state, openSshTerminal: { ...state.openSshTerminal, loading: action.payload } };
    case vpsOciTypes.OPEN_SSH_TERMINAL_SET_DATA:
      return { ...state, openSshTerminal: { ...state.openSshTerminal, url: action.payload } };

    case vpsOciTypes.SET_TOUR_DATA:
      return { ...state, tour: { ...state.tour, canShowTour: action.payload } };

    case vpsOciTypes.SET_LOADING_LISTING_UPGRADE_VPS_OCI:
      return { ...state, upgrade: { ...state.upgrade, listing: { ...state.upgrade.listing, loading: action.payload } } };
    case vpsOciTypes.SET_DATA_LISTING_UPGRADE_VPS_OCI:
      return { ...state, upgrade: { ...state.upgrade, listing: { ...state.upgrade.listing, data: action.payload } } };

    case vpsOciTypes.SET_DATA_DETAILS_UPGRADE_VPS_OCI:
      return { ...state, upgrade: { ...state.upgrade, details: { ...state.upgrade.details, data: action.payload } } };
    case vpsOciTypes.SET_LOADING_DETAILS_UPGRADE_VPS_OCI:
      return { ...state, upgrade: { ...state.upgrade, details: { ...state.upgrade.details, loading: action.payload } } };

    case vpsOciTypes.SET_LOADING_UPGRADE_VPS_OCI:
      return { ...state, upgrade: { ...state.upgrade, submit: { ...state.upgrade.submit, loading: action.payload } } };
    case vpsOciTypes.SET_DATA_UPGRADE_VPS_OCI:
      return { ...state, upgrade: { ...state.upgrade, submit: { ...state.upgrade.submit, data: action.payload } } };
    case vpsOciTypes.RESET_UPGRADE_VPS_OCI:
      return { ...state, upgrade: { ...initialState.upgrade } };


    case vpsOciTypes.SAVE_TOKEN_OPENCLAW_SET_LOADING:
      return { ...state, openClaw: { ...state.openClaw, loading: action.payload } };
    case vpsOciTypes.SAVE_TOKEN_OPENCLAW_SET_SUCCESS:
      return { ...state, openClaw: { ...state.openClaw, success: action.payload } };

    case vpsOciTypes.CONFIGURE_GATORCLAW_SET_LOADING:
      return { ...state, gatorClaw: { ...state.gatorClaw, loading: action.payload } };
    case vpsOciTypes.CONFIGURE_GATORCLAW_SET_SUCCESS:
      return { ...state, gatorClaw: { ...state.gatorClaw, success: action.payload } };

    default:
      return state;
  }
};

export default vpsOciReducer;
